import React, { useEffect, useRef, useState } from 'react';
import './comapre-quotes-table.css';
import OptimizationStore from '../../../modules/optimization/store/OptimizationStore';
import CustomizationLoader from '../customization-loader/CustomizationLoader';
import DefaultPPTForCompareQuotes from "../../../constants/DefaultPPTForCompareQuotes"
import prefillDeathCoverGraphSliderAllAmounts from 'utils/forward-reverse-methods/prefillDeathCoverGraphSliderAllAmounts';
import BottomsheetDropdown from '../bottomsheet-dropdown/BottomsheetDropdown';
import { COMPARE_BI_TABLE_PPT, COMPARE_BI_TABLE_PREMIUM, COMPARE_BI_TABLE_PT } from 'constants/UserClicksConstant';
import AuthStore from 'modules/login/store/AuthStore';

function ComapreQuotesTable({ form, ptList, pptList, productData, cardKey, ptValueId, ptName, pptName }) {

    const [pptData, setPPTData] = useState({
        firstPPT: "",
        secondPPT: "",
        thirdPPT: ""
    })

    const [premium, setPremium] = useState({
        firstPremium: 0,
        secondPremium: 0,
        thirdPremium: "-"
    })
    const [PPTList, setPPTList] = useState(pptList)
    const [PTList, setPTList] = useState(ptList)
    const [PT, setPT] = useState(ptValueId)
    const [PPT, setPPT] = useState("")
    const [showTable, setShowTable] = useState(false)
    useEffect(() => {
        let pptlistBE = DefaultPPTForCompareQuotes[productData.data.package_id]
        if (pptlistBE?.length > 1 && showTable) {
            let firstPPTID = pptList.find((item) => String(item.id) === String(pptlistBE[0]))
            let secondPPTID = pptList.find((item) => String(item.id) === String(pptlistBE[1]))
            setPPTData({
                firstPPT: firstPPTID,
                secondPPT: secondPPTID,
                thirdPPT: "-"
            });
            let data = pptList.filter(item => !pptlistBE.includes(item.label));
            setPPTList(data);
            setPremium(prevState => ({
                ...prevState,
                firstPremium: "",
                secondPremium: ""
            }));
            let fetchData = async () => {
                let bi_request = productData.data?.bi_request;
                bi_request["PR_PT"] = PT.id;
                bi_request["PR_PPT"] = firstPPTID?.id;
                bi_request["INPUT_MODE"] = "1"
                let calculatedData1 = await OptimizationStore.calculatePremiumAmmount(productData, bi_request);
                calculatedData1 = calculatedData1 === 0 ? "-" : global.toINR(calculatedData1)
                setPremium(prevState => ({
                    ...prevState,
                    firstPremium: calculatedData1
                }));

                bi_request["PR_PT"] = PT.id;
                bi_request["PR_PPT"] = secondPPTID?.id;
                let calculatedData2 = await OptimizationStore.calculatePremiumAmmount(productData, bi_request);

                calculatedData2 = calculatedData2 === 0 ? "-" : global.toINR(calculatedData2)

                setPremium(prevState => ({
                    ...prevState,
                    secondPremium: calculatedData2
                }));
            };
            fetchData();
        } else {
            setPremium(prevState => ({
                ...prevState,
                firstPremium: "-",
                secondPremium: "-"
            }));
        }
    }, [showTable]);

    useEffect(() => {
        let pptlistBE = DefaultPPTForCompareQuotes[productData.data.package_id]
        if (pptlistBE?.length > 1 && showTable) {
            let updatedPtList = pptList.filter(item => !pptlistBE.includes(item.label));
            setPPTList(updatedPtList)
            setPTList(ptList)
        }
    }, [pptList, ptList, showTable])


    const handlePTChange = async (event) => {

        //! for save user clicks
        AuthStore.saveUserClicks(COMPARE_BI_TABLE_PT)
        let ptValue = event
        setPT(ptValue);
        if (pptData.thirdPPT !== "-") {
            setPremium({ firstPremium: "", secondPremium: "", thirdPremium: "" })
        } else {
            setPremium(prevState => ({
                ...prevState, firstPremium: "", secondPremium: ""
            }));
        }

        for (const [key, value] of Object.entries(pptData)) {
            if (value !== "-") {
                let bi_request = productData.data?.bi_request
                bi_request["PR_PT"] = ptValue.id
                bi_request["PR_PPT"] = value?.id ? value?.id : value
                bi_request["INPUT_MODE"] = "1"

                let calculatedData = await OptimizationStore.calculatePremiumAmmount(productData, bi_request)

                calculatedData = calculatedData === 0 ? "-" : global.toINR(calculatedData)
                switch (key) {
                    case "firstPPT":
                        setPremium(prevState => ({
                            ...prevState,
                            firstPremium: calculatedData
                        }));
                        break;
                    case "secondPPT":
                        setPremium(prevState => ({
                            ...prevState,
                            secondPremium: calculatedData
                        }));
                        break;
                    case "thirdPPT":
                        setPremium(prevState => ({
                            ...prevState,
                            thirdPremium: calculatedData
                        }));
                        break;

                    default:
                        break;
                }
            }
        }
    }

    const handlePPTChange = async (event) => {

        if (PPT != event) {
            //! for save user clicks
            AuthStore.saveUserClicks(COMPARE_BI_TABLE_PPT)
            let pptValue = event
            setPPT(pptValue)
            let bi_request = productData.data?.bi_request
            setPremium(prevState => ({ ...prevState, thirdPremium: "" }));

            bi_request["PR_PT"] = PT.id
            bi_request["PR_PPT"] = pptValue.id
            bi_request["INPUT_MODE"] = "1"

            let calculatedData = await OptimizationStore.calculatePremiumAmmount(productData, bi_request)

            calculatedData = calculatedData === 0 ? "-" : global.toINR(calculatedData)
            setPPTData(prevState => ({
                ...prevState,
                thirdPPT: pptValue
            }));

            setPremium(prevState => ({
                ...prevState,
                thirdPremium: calculatedData
            }));
        }
    }

    const getBIData = async (productData, pt, ppt, premium) => {

        let ptId = form?.$(ptName)?.value
        let pptId = form?.$(pptName)?.value
        if (premium !== "-") {
            if (String(pt?.id) !== String(ptId?.id) || String(ppt?.id) !== String(pptId?.id)) {
                //! for save user clicks
                AuthStore.saveUserClicks(COMPARE_BI_TABLE_PREMIUM)
                // let pptID = pptList.find((item) => String(item.id) === ppt.id)
                // let ptID = ptList.find((item) => String(item.id) === pt.id)
                form.$(ptName).set('value', pt)
                form.$(pptName).set('value', ppt)

                let bi_request = productData.data?.bi_request
                bi_request["PR_PT"] = pt?.id
                bi_request["PR_PPT"] = ppt?.id
                bi_request["INPUT_MODE"] = "1"
                OptimizationStore.biTablePremiumClick(productData.data.family_product_id)
                // OptimizationStore.resetFieldChangeEvent(productData.data.family_product_id);
                await OptimizationStore.updateStoreRequestData(productData.data.product_id, bi_request, productData.data.family_product_id);
            }
        }
    }

    const premiumlabel = (cardKey, productData) => {

        if (cardKey !== "protection_for_my_family") {
            if (productData?.payout_mode === "income" || productData?.payout_mode === "recommended_income") {
                return "Annual Income"
            } else if (productData?.payout_mode === "lumpsum") {
                return "Lumpsum Benefit"
            }
        } else {
            return "Life Cover"
        }
    }

    const incomeAmount = (ProductData) => {
        let data = prefillDeathCoverGraphSliderAllAmounts(ProductData?.data)
        return data.targetValue
    }

    return (
        <>
            <div  className='btn text-primary p-0 LA-btn font-size-14 font-weight-medium mb-1' onClick={() => { setShowTable(!showTable) }}>{showTable ? "[Hide Compare Premium]" : "[Show Compare Premium]"}</div>
            {showTable &&
                <>
                    <div className='d-flex' >
                        <table className={`w-50  ${window.innerWidth > 420 ? 'd-table' : 'd-none'} `}>
                            <tr>
                                <th className='font-size-13 font-size-md-14  font-weight-normal comapre-bi-table-th'>Premium for {premiumlabel(cardKey, productData?.data)} of Rs. {incomeAmount(productData)}</th>
                            </tr>
                        </table>
                        <table className="comapre-bi-table">
                            <thead>
                                <tr className={`${window.innerWidth <= 420 ? 'd-table-row' : 'd-none'} `}>
                                    <th colSpan="5" className='text-center font-size-13 font-size-md-14 font-weight-normal comapre-bi-table-th'>Premium for {premiumlabel(cardKey, productData?.data)} of Rs. {incomeAmount(productData)}</th>
                                </tr>
                                <tr>
                                    <th className='comapre-bi-table-th'></th>
                                    <th colSpan="5" className='text-center font-size-13 font-size-md-14 font-weight-normal  comapre-bi-table-th'>PPT</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='font-weight-bold'>
                                    <th className='text-center font-size-13 font-size-md-14  font-weight-normal comapre-bi-table-th'>PT</th>
                                    <td className='text-center font-size-13 font-size-md-14  comapre-bi-table-td'>{pptData.firstPPT?.label}</td>
                                    <td className='text-center font-size-13 font-size-md-14  comapre-bi-table-td'>{pptData.secondPPT?.label}</td>
                                    <td className='text-center comapre-bi-table-td'>
                                        {/* <select value={PPT} className='w-100' onChange={(e) => { handlePPTChange(e) }}>
                                <option value="" disabled hidden>Select an option</option>
                                {PPTList.map(item => (
                                    <option key={item.id} value={item.id}>{item.label}</option>
                                ))}

                            </select> */}
                                        <BottomsheetDropdown
                                            dropdownStyle='font-size-12  font-weight-light'
                                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                            menuItemStyle='d-flex justify-content-between align-items-center'
                                            selectedLabelKey='label'
                                            bottomsheetTitle={""}
                                            menuList={PPTList}
                                            value={PPT}
                                            onSelect={(e) => { handlePPTChange(e) }}
                                            disabled={false}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th className='comapre-bi-table-th'>
                                        {/* <select className='w-100' value={PT} onChange={handlePTChange}>
                                {PTList.map(item => (
                                    <option key={item.id} value={item.id}>{item.label}</option>
                                ))}
                            </select> */}
                                        <BottomsheetDropdown
                                            dropdownStyle='font-size-12 font-weight-light'
                                            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
                                            menuItemStyle='d-flex justify-content-between align-items-center'
                                            selectedLabelKey='label'
                                            bottomsheetTitle={""}
                                            menuList={PTList}
                                            value={PT}
                                            onSelect={handlePTChange}
                                            disabled={false}
                                        />
                                    </th>
                                    <td className={`text-center text-primary font-size-13 font-size-md-14 ${premium.firstPremium !== "-" ? 'underline-text pointer' : ''} comapre-bi-table-td `} ><div onClick={() => getBIData(productData, PT, pptData.firstPPT, premium.firstPremium)}> {premium.firstPremium === "" ? <CustomizationLoader /> : premium.firstPremium}</div></td>
                                    <td className={`text-center text-primary font-size-13 font-size-md-14 ${premium.secondPremium !== "-" ? 'underline-text pointer' : ''} comapre-bi-table-td `} ><div onClick={() => getBIData(productData, PT, pptData.secondPPT, premium.secondPremium)}>{premium.secondPremium === "" ? <CustomizationLoader /> : premium.secondPremium}</div></td>
                                    <td className={`text-center text-primary font-size-13 font-size-md-14 ${premium.thirdPremium !== "-" ? 'underline-text pointer' : ''} comapre-bi-table-td `} ><div onClick={() => getBIData(productData, PT, pptData.thirdPPT, premium.thirdPremium)}>{premium.thirdPremium === "" ? <CustomizationLoader /> : premium.thirdPremium}</div></td>
                                </tr>
                            </tbody>
                        </table>


                    </div>
                    <p className='text-center'>Click on a premium to generate a quotation for that combination.</p>
                </>
            }
        </>
    );
}

export default ComapreQuotesTable;
